<script setup>
import combinationStorage from '@/services/combination-storage';
import { defineOptions, onMounted, reactive } from 'vue';
import Pagination from '@/components/Pagination.vue';

defineOptions({
  name: 'ModalBodyProductList'
});

const state = reactive({
  category: null,
  parentCategory: null,
  items: [],
  q: '',
  page: 1,
  pagination: [],
});

onMounted(() => {
  loadItems();
});

async function loadItems() {
  const connectorProductIds = [];

  if (
    combinationStorage.categoryType === 'cable'
    && combinationStorage.initialItem
    && combinationStorage.terminalItem
  ) {
    connectorProductIds.push(combinationStorage.initialItem.productId);
    connectorProductIds.push(combinationStorage.terminalItem.productId);
  }

  const res = await u.$http.get(
    '@combination_ajax/loadProductList',
    {
      params: {
        q: state.q,
        path: combinationStorage.categoryPath,
        page: state.page,
        mappingIds: combinationStorage.mappingIds,
        combinationShowIn: combinationStorage.categoryType,
        connectorProductIds: connectorProductIds,
        getMappingConnector: combinationStorage.getMappingConnector ? 1 : 0,
      }
    }
  );

  state.category = res.data.data.category;
  state.parentCategory = res.data.data.parentCategory;
  state.items = res.data.data.items;
  state.pagination = res.data.data.pagination;
}

async function goToPage(v) {
  state.page = v;

  await loadItems();
}

function goToNextPage(component) {
  combinationStorage.modalCurrentComponent = component;
}
</script>

<template>
  <div v-if="state.items" class="modal-body pt-0">
    <nav v-if="combinationStorage.showBreadcrumb"
      aria-label="breadcrumb" class="c-breadcrumb-nav d-none d-md-block p-0">
      <div class="container-fluid p-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="javascript://"
              @click="combinationStorage.backToComponent('buttons')">
              產品分類
            </a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript://"
              @click="combinationStorage.goToCategoryList(state.parentCategory?.path)">
              {{ state.parentCategory?.title }}
            </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ state.category?.title }}
          </li>
        </ol>
      </div>
    </nav>

    <button class="c-prev btn d-md-none mb-3 border-0 px-3 w-100 text-start position-absolute top-0 start-0"
      @click="combinationStorage.goToCategoryList(state.parentCategory?.path)">
      <i class="fa-regular fa-chevron-left me-2"></i>
      {{ state.parentCategory?.title }}
    </button>

    <div class="c-search d-flex mb-4 position-relative">
      <input v-model="state.q" type="text" class="form-control" placeholder="產品搜尋">
      <i class="fa-regular fa-magnifying-glass"></i>
      <button type="button" class="btn btn-dark"
        @click="loadItems"
      >搜尋
      </button>
    </div>

    <ul class="c-product-card-list">
      <li v-for="item in state.items" :key="'product-' + item.id">
        <a href="javascript://" class="text-decoration-none btn border-0 p-0 text-start h-100"
          @click="combinationStorage.goToProductItem(item.id)">
          <div class="card h-100">
            <img :src="item.variant.cover"
              class="card-img-top" alt="product title">

            <div class="card-body position-relative">
              <div class="d-flex flex-wrap gap-2 mb-3">
                <div v-for="tag in item.tags" class="badge bg-primary">{{ tag.title }}</div>
              </div>

              <h2 class="card-title h5 mb-1 fw-medium position-relative">{{ item.title }}</h2>
              <p class="card-text mb-3">{{ item.model }}</p>
              <div class="c-card-price h4 text-dark fw-medium mb-0">
                <template v-if="item.variants">
                  {{ $formatPrice(item.min_price, true, true, $getDecimalPlace(item.min_price)) }}
                  <span>起</span>
                </template>
                <template v-else>
                  {{ $formatPrice(item.variant.priceSet.final.price, true, true, $getDecimalPlace(item.variant.priceSet.final.price)) }}
                </template>
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>

    <Pagination :item="state.pagination"
      :enableLessAndMore="false"
      :enableFirstAndLast="false"
      :icon="{ prev: 'fa-regular fa-chevron-left', next: 'fa-regular fa-chevron-right' }"
      @go="goToPage"
    ></Pagination>
  </div>
</template>
